import { Modal, Button, Form } from "react-bootstrap";
import { useEffect, useState } from "react";

export default function PdfUploadModal({ show, onClose, onFileSelected }) {
  const [fileError, setFileError] = useState("");

  useEffect(() => {
    if (!show) setFileError("");
  }, [show]);

  const handleClose = () => {
    setFileError("");
    onClose?.();
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (file.type !== "application/pdf") {
      setFileError("Only PDF files are allowed.");
      return;
    }

    setFileError("");
    onFileSelected?.(file);
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Upload Resume (PDF)</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form.Group controlId="uploadPDF">
          <Form.Label>Select a PDF file</Form.Label>
          <Form.Control
            type="file"
            accept="application/pdf"
            onChange={handleFileChange}
          />
        </Form.Group>

        {fileError && (
          <p className="text-danger mt-2" style={{ fontSize: "0.9rem" }}>
            {fileError}
          </p>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
}